import React from 'react'
import { BaseCheckbox } from './base-checkbox'

export interface CheckboxProps {
  value?: boolean
  id?: string
  disabled?: boolean
  label?: string | React.ReactNode
  onChange: (newValue: boolean) => void
}

export const Checkbox = ({
  disabled = false,
  onChange,
  value = false,
  ...props
}: CheckboxProps) => {
  const handleValueChange = () => {
    if (value === true) {
      onChange(false)
    } else {
      onChange(true)
    }
  }

  return (
    <BaseCheckbox
      {...props}
      disabled={disabled}
      value={value}
      onClick={() => !disabled && handleValueChange()}
    />
  )
}
